<template>
  <div>
    <title-row
      title="QR kód jóváhagyás"
      :breadcrumb-items="[
        {
          text: 'QR kód jóváhagyás',
          disabled: true,
        },
      ]">
    </title-row>

    <v-card class="rounded-xl" flat>
      <v-tabs v-model="tab" align-tabs="center" color="text--primary">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab key="waiting_for_approval">Elfogadásra váró igénylések</v-tab>
        <v-tab key="approved_requests">Elfogadott igénylések</v-tab>

        <v-tabs-items v-model="tab">
          <v-tab-item key="waiting_for_approval" :transition="false">
            <TabApprovals :approved="false"/>
          </v-tab-item>
          <v-tab-item key="approved_requests" :transition="false">
            <TabApprovals :approved="true"/>
          </v-tab-item>

        </v-tabs-items>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import TabApprovals from './TabApprovals.vue';

export default {
  components: {
    TabApprovals,
  },

  data() {
    return {
      tab: 0,
    };
  },
};
</script>
